// import Swiper core and required modules
import Swiper from 'swiper';
import { Navigation, Pagination } from 'swiper/modules';
// enable modules on the global Swiper
Swiper.use([Navigation, Pagination]);
window.Swiper = Swiper;
